module.exports = __webpack_public_path__ + "img/jiejue1.3aa5b7d2.png";